import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import NumberStepper from "core/inputs/number-stepper/NumberStepper";
import StepHeader from "./StepHeader";

const ABSENCES_MIN = 0;
const ABSENCES_MAX = 10;

// Half-days of absence for the week (0-10) → half_day_absences field of the declaration.
const AbsencesStep = ({ value, onChange }) => (
  <div className="faf-step">
    <StepHeader>
      <FormattedMessage
        id="tools_manager_faf_absences_title"
        defaultMessage="Combien de demi-journées d'absence cette semaine ?"
      />
    </StepHeader>
    <p className="faf-field-label">
      <FormattedMessage
        id="tools_manager_faf_absences_field_label"
        defaultMessage="Nombre d'absences"
      />
    </p>
    <NumberStepper
      id="faf-absences"
      dataTestId="faf-absences-stepper"
      value={value}
      onChange={onChange}
      min={ABSENCES_MIN}
      max={ABSENCES_MAX}
    />
    <Typography
      type="p"
      className="faf-help text-3"
      label={
        value === 0 ? (
          <FormattedMessage
            id="tools_manager_faf_absences_help_none"
            defaultMessage="Aucune absence déclarée pour le moment — semaine complète."
          />
        ) : (
          <FormattedMessage
            id="tools_manager_faf_absences_help_count"
            defaultMessage="{days, plural, one {# jour non travaillé} other {# jours non travaillés}}"
            values={{ days: value / 2 }}
          />
        )
      }
    />
  </div>
);

AbsencesStep.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AbsencesStep;
